import { createContext, useContext } from 'react';

export interface EditOrderContextType {
  orderId: string;
  userId: string;
  isEditable: boolean;
}

export const EditOrderContext = createContext<EditOrderContextType | null>(null);

export const useEditOrderContext = () => {
  const context = useContext(EditOrderContext);
  if (!context) {
    throw new Error('EditOrderContextType not found');
  }
  return context;
};
